import withConfigTransport from '../../services/config-transport/withConfigTransport'
import Component from './VaTimeInput.vue'
export const VaTimeInput = withConfigTransport(Component) as typeof Component
